module.exports = __webpack_public_path__ + "static/media/hero1.78b9b87f.jpg";